import { Asset, AssetActivitiesResponse, AssetData, AssetDto, AssetListResponse, AssetStatus, ClearPeriod, DownloadJobStatusResponse } from "types/asset";
import { blobDownload, genericDelete, genericGet, genericPost, genericPut, UploadFile } from "./base.api";
import { getDataApiUrl } from "utils/utils";

export function getAssetStatuses(): Promise<AssetStatus[]> {
  return genericGet(`${getDataApiUrl()}/asset_statuses`)
}

export function getAssetStatusClearPeriods(): Promise<ClearPeriod[]> {
  return genericGet(`${getDataApiUrl()}/asset_status_clear_periods`)
}

export function getAssetList(params?: Record<string, any>): Promise<AssetListResponse> {
  return genericGet(`${getDataApiUrl()}/localized/assets`, params)
  // .then(res => {
  //   res.items.forEach(r => r.location = {
  //     "venue": {
  //       "id": "5e417c00-1023-4ca7-9d1b-0e4ce5c80fca",
  //       "name": "cumberlandinfirmary"
  //     },
  //     "region": {
  //       "id": "646aea7e-ceb2-4379-8c42-58d46a48b808",
  //       "name": "A&E Treatment Room 1A-4A",
  //     },
  //     "coordinates": {
  //       "latitude": random(54.89615087764397, 54.89699997764397),
  //       "longitude": random(-2.9581268886953555, -2.9589999996953555)
  //     },
  //     "uncertainty": 9.153183175800523,
  //     "is_outdoors": false,
  //     "building_level": {
  //       "possible_buildings": [
  //         {
  //           "id": "3cc3c63b-c5e5-471c-891e-9f652965f41b",
  //           "name": "Main"
  //         }
  //       ],
  //       "level": {
  //         "id": "0e556a57-3efe-425d-aa02-fb19f7b70130",
  //         "name": "Floor 0",
  //         "short_name": "0"
  //       },
  //     }
  //   }
  //   )
  //   return res
  // });
}

export function getAssetById(id: string): Promise<Asset | null> {
  return genericGet(`${getDataApiUrl()}/localized/assets`, {
    asset_id_filter: id
  }).then((res: any) => {
    return res.items.length > 0 ? res.items[0] : null
  })
}

export function getAssetActivities(asset_id: string): Promise<AssetActivitiesResponse> {
  return genericGet(`${getDataApiUrl()}/asset_status_assignments/${asset_id}`);
}

export function ArchiveAsset(asset_id: string): Promise<any> {
  return genericDelete(`${getDataApiUrl()}/assets/${asset_id}`)
};

export function UpdateAssetStatus(asset_id: string, asset_status_id: string | null, clear_at_timestamp: string | null): Promise<any> {
  return genericPost(`${getDataApiUrl()}/asset_status_assignment`, {
    asset_id: asset_id,
    asset_status_id: asset_status_id,
    clear_at_timestamp: clear_at_timestamp
  })
}

export function getAsset(asset_id: string): Promise<AssetDto> {
  return genericGet(`${getDataApiUrl()}/assets/${asset_id}`)
}

export async function isAssetNameExists(assetId: string, assetName: string) {
  const params = { name_filter: assetName }
  const res = await getAssetList(params)
  if (res.items.length > 0)
    return res.items.find(r => r.asset_name.toLowerCase() === assetName.toLocaleLowerCase() && r.asset_id !== assetId)
  return false
};

export async function isAssetIdExists(assetId: string) {
  const params = { asset_id_filter: assetId }
  const res = await getAssetList(params)
  return res.items.length > 0
};

export function CreateAsset(obj: AssetData): Promise<boolean> {
  return genericPost(`${getDataApiUrl()}/assets`, { asset: obj });
}

export function UpdateAsset(obj: AssetDto): Promise<boolean> {
  return genericPut(`${getDataApiUrl()}/assets`, { asset: obj });
}

export function createDownloadJob(): Promise<{ job_id: string }> {
  return genericPost(`${getDataApiUrl()}/entity/asset/export/job`, null);
};

export function getDownloadJobStatus(jobID: string): Promise<DownloadJobStatusResponse> {
  return genericGet(`${getDataApiUrl()}/entity/asset/export/job/${jobID}/status`)
};

export function CreateLogExportJob(start_date: string, end_date: string): Promise<{ job_id: string }> {
  const queryString = new URLSearchParams();
  queryString.append('start_date', start_date);
  queryString.append('end_date', end_date);
  return genericPost(`${getDataApiUrl()}/event/change/asset/export/job?${queryString.toString()}`, null)
};

export function GetLogExportJobStatus(jobId: string | null): Promise<DownloadJobStatusResponse> {
  return genericGet(`${getDataApiUrl()}/event/change/asset/export/job/${jobId}/status`)
};

export function DownloadTemplateFile() {
  return blobDownload(`${getDataApiUrl()}/entity/asset/job/template`, null, 'GET', 'asset_import_template.csv')
};

export function UploadAssets(file: any) {
  return UploadFile(`${getDataApiUrl()}/assets/bulk_upload`, file)
}